// src/components/PlayerHand.js
import React, { useState } from 'react';
import { useGame } from '../contexts/GameContext';
import Card from './Card';
import TokenDetailModal from './TokenDetailModal';
import './PlayerHand.css';

function PlayerHand({ player, disabled }) {
  const { selectedCards, selectHandCard } = useGame();
  const [showTokenModal, setShowTokenModal] = useState(false);

  if (!player) return null;

  return (
    <div className="player-hand-container">
      <div className="player-hand">
        {player.hand.length === 0 ? (
          <div className="empty-hand">手牌为空</div>
        ) : (
          player.hand.map((card, index) => (
            <Card
              key={`hand-${index}`}
              card={card}
              selected={selectedCards.hand.includes(index)}
              onClick={() => !disabled && selectHandCard(index)}
              disabled={disabled}
            />
          ))
        )}
      </div>

      <div className="player-stats">
        <div className="stat">
          <span className="stat-label">代币:</span>
          <span
            className="stat-value clickable"
            onClick={() => setShowTokenModal(true)}
            title="点击查看代币详情"
          >
            🪙 {player.tokens?.length || 0}
          </span>
        </div>
        <div className="stat">
          <span className="stat-label">总分:</span>
          <span className="stat-value">⭐ {player.score}</span>
        </div>
      </div>

      <TokenDetailModal
        tokens={player.tokens || []}
        isOpen={showTokenModal}
        onClose={() => setShowTokenModal(false)}
      />
    </div>
  );
}

export default PlayerHand;
